module.exports = __webpack_public_path__ + "images/emoji/pizza.486cf5f539065838329a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/pizza.png
// module id = 2jJb
// module chunks = 1